import React, { useEffect } from 'react'
import './Accueil.css'
import { Entete } from '../../Entete/Entete';
import { AffichageUser } from '../User/Affichage/Affichage';
import { useNavigate, useOutletContext } from 'react-router-dom';
import { Identifiant } from '../../../Models/Identifiant/IdentifiantModels';

export function Accueil(){
  const contextDonnees = useOutletContext<any[]>();
  const identifiantsContext:Identifiant[] = contextDonnees[6];
  const obtentionDonnees:()=>Promise<void> = contextDonnees[3];
  let navigate = useNavigate();

  const themeUser = ()=>{
    //réutilisation de chagement css écrit en dur à l'origine dans Login
    document.documentElement.style.setProperty(
        '--interface-width-pourcentage',
        '100%',
    );
    document.documentElement.style.setProperty(
        '--interface-height-pourcentage',
        '90%',
    );
    document.documentElement.style.setProperty(
        '--interface-margin-left',
        '25%',
    )
    document.documentElement.style.setProperty(
        '--interface-width-mobil',
        '100vw',
    )
    document.documentElement.style.setProperty(
        '--interface-margin-left-mobil',
        '0%',
    )
    document.documentElement.style.setProperty(
        '--interface-margin-top-mobil',
        '0vh',
    )
    document.documentElement.style.setProperty(
        '--interface-margin-bot-mobil',
        '0%',
    )
    document.documentElement.style.setProperty(
        '--interface-height-mobil',
        '100%',
    )
    document.documentElement.style.setProperty(
        '--interface-border-radius',
        '0px',
    )
  }
  
  useEffect(()=>{
    themeUser();
    obtentionDonnees();
    if(identifiantsContext.length>1)navigate('/admin');
    return ()=>{};
  },[identifiantsContext.length, navigate, obtentionDonnees]);

  //gestion drawer depuis entete
  const [mobileOpen, setMobileOpen] = React.useState(false);
  const [isClosing, setIsClosing] = React.useState(false);

  const handleDrawerClose = () => {
    setIsClosing(true);
    setMobileOpen(false);
  };
  const handleDrawerTransitionEnd = () => {
    setIsClosing(false);
  };

  return (
    <>
      <div className='container-entete'>
        <Entete mobileOpen={mobileOpen} setMobileOpen={setMobileOpen} isClosing={isClosing} setIsClosing={setIsClosing}/>
      </div>
      <div className="container-interface">
        <div className="Interface">
          <div className='Accueil-affichage'>
            <AffichageUser mobileOpen={mobileOpen} handleDrawerClose={handleDrawerClose} handleDrawerTransitionEnd={handleDrawerTransitionEnd}/>
          </div>
        </div>
      </div>
    </>
  )
}